/**
 * Message Type that can be sent to a ChargePoint
 */
export enum ChargingProfileKindType {
    ABSOLUTE = 'ABSOLUTE',
    RECURRING = 'RECURRING',
    RELATIVE = 'RELATIVE'
}
